module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOTIwIDYyLjA0Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I0Y3RjdGNzt9PC9zdHlsZT48L2RlZnM+PGcgaWQ9IuWbvuWxgl8yIiBkYXRhLW5hbWU9IuWbvuWxgiAyIj48ZyBpZD0i5Zu+5bGCXzEtMiIgZGF0YS1uYW1lPSLlm77lsYIgMSI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMCwwVjYySDE5MjBWMFMxNTQ2Ljg2LDQ0LjQyLDk2MCw0NC40MiwwLDAsMCwwWiIvPjwvZz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/home-banner-cover.svg
// module id = NGLs
// module chunks = 1